export enum DefinitionType {
  TerminalTypes = 0,
  ManualCorrectionReasons = 1,
  ManualGrantPassageReasons = 2,
  NotificationLevels = 3,
  NotificationTypes = 4,
  ParkerTypes = 5,
}
